import Survey from './Survey';
import {authRoles} from "../../../../store/actionreducers/auth/auth";

export const SurveyConfig = {
    auth: authRoles.admin, //  ['cc']
    routes: [
        {
            path: '/apps/survey/',
            component: Survey
        }
    ]
};



// WEBPACK FOOTER //
// ./src/main/content/callHelper/survey/SurveyConfig.js